export default __webpack_public_path__ + "static/media/trek.e3c5c621.jpg";